export enum ActiveLinkTypeDnaplate {
  SequenceUpload = 'sequenceUpload',
  OligoConfiguration = 'oligoConfiguration',
  Specifications = 'specifications',
  PackingAndShipping = 'packingAndShipping',
  OrderConfirmation = 'orderConfirmation',
  ProductType = 'dnaplate',
}
export enum Specifications {
  concentration = 'concentration',
  amount = 'amount',
  volume = 'volume',
  format = 'format',
  purification = 'purification',
  scale = 'scale',
  normalization = 'normalization',
  daughterPlates = 'daughterPlates',
  category = 'category',
  packagetype96 = 'packagetype96',
  packagetype384 = 'packagetype384',
  shipping = 'shipping',
  packageType = 'packageType',
  packagetype = 'packagetype',
  DRY = 'DRY',
  Ambient = 'Ambient',
  PLATE_96_DEEP_800 = 'PLATE_96_DEEP_800',
  Yes = 'Yes',
  No = 'No',
  excessmaterial = 'excessmaterial',
  STANDARD = 'STANDARD',
  MIXED = 'MIXED',
  daughterPlatesValue = '0',
  Shallow_well_40 = 'Shallow_well_40',
  Other = 'Other',
  PackageTypeOther = 'other',
  concentartionOther = 'concentartionOther',
  RequiredField = 'Required Field',
}

export enum Status {
  success = 'success',
  error = 'error',
}
export enum image {
  png = '.png',
}
export enum templatenames {
  dnaplate_96well_8ch = 'dnaplate_96well_8ch',
  dnaplate_96well_8ch_mixed = 'dnaplate_96well_8ch_mixed',
  dnaplate_96well_12ch = 'dnaplate_96well_12ch',
  dnaplate_96well_12ch_mixed = 'dnaplate_96well_12ch_mixed',
  dnaplate_384well = 'dnaplate_384well',
  dnaplate_384well_mixed = 'dnaplate_384well_mixed',
  duplexplate_96well_8ch = 'duplexplate_96well_8ch',
  duplexplate_96well_12ch = 'duplexplate_96well_12ch',
  duplexplate_384well = 'duplexplate_384well',
}

export enum scaleValues {
  UMO25 = '0.0250 UMO',
  UMO50 = '0.0500 UMO',
  UMO1 = '1.0000 UMO',
  UMO2 = '0.2000 UMO',
  scale1 = '1.0',
  scaleToDispay = '1',
}

export enum shippingValues {
  Ambient = 'Ambient',
  Ice = 'Ice',
  DryIce = 'Dry Ice',
}

export enum price {
  priceQuote = 'QUOTE',
  NaN = 'NaN',
}

export enum plate {
  NewPlate = 'New Plate',
}
export enum modificationNone {
  none = '[None]',
  DuplexOverhang = '[dT][dT]',
}

export enum FileFormat {
  InvalidTemplate = 'INVALID_TEMPLATE',
  MultipleLineError = 'MULTIPLE_LINE_ERROR',
  AcceptFormat = '.csv,.xls,.xlsx, text/csv,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/vnd.ms-excel',
}

export enum ErrorMessage {
  SessionDataEmpty = 'ERROR_SESSION_DATA_EMPTY',
  AccessTokenExpire = 'ERROR_USER_INVALID_OR_EXPIRED_ACCESS_TOKEN',
  Success = 'success',
}

export enum PlateProduct {
  DnaPlate = 'dnaplate',
  DuplexPlate = 'duplexplate',
  wellType = 384,
  wellType96 = 96,
}

export enum UploadType {
  SiRNA_96well_8channel = 'siRNA 96-well_8chan.',
  SiRNA_96well_12channel = 'siRNA 96-well_12chan.',
  SiRNA_384well = 'siRNA 384-well',
  copyPaste = 'copyPaste',
  fileUpload = 'fileUpload',
}

export enum WarningKey {
  antisencesequence_mismatch = 'antisencesequence_mismatch',
  antisenceName = 'antisenceName',
  name = 'name',
  sequence = 'sequence',
}
export enum DnaplateFileHeaders {
  Row = 'Row',
  Column = 'Column',
  Name = 'Name',
  Mod_5 = "5' Mod",
  Sequence = "Sequence (5' - 3')",
  Mod_3 = "3' Mod",
  ModificationDescription = 'Modification Description',
  Position = 'Position',
  Code = 'Code',
}

export enum CountryCodes {
  JP = 'JP',
  IN = 'IN',
}

export enum formatedScaleValues {
  SCALE_4digit = ' UMO',
}

export const USExportCountriesListFor384Well = [
  'AG',
  'AI',
  'AN',
  'AR',
  'AS',
  'AW',
  'BB',
  'BR',
  'BM',
  'BO',
  'BS',
  'BT',
  'BZ',
  'CL',
  'CO',
  'CR',
  'CU',
  'DM',
  'DO',
  'EC',
  'GD',
  'GT',
  'GU',
  'GY',
  'HK',
  'HN',
  'HT',
  'JM',
  'KI',
  'KN',
  'KP',
  'KY',
  'LC',
  'MH',
  'MO',
  'MS',
  'MV',
  'MX',
  'NI',
  'NR',
  'PA',
  'PE',
  'PN',
  'PY',
  'SB',
  'SH',
  'SR',
  'ST',
  'SV',
  'TC',
  'TT',
  'TV',
  'US',
  'UY',
  'VC',
  'VE',
  'VG',
  'VI',
  'VU',
  'WF',
  'FO',
]

export const minimumWellsExecptionCountries = ['NL', 'FR']

export const australianCountries = ['AU', 'NZ']
